import { useEffect } from "react";

const useAdManaSlot = ({ path, size, id }) => {
  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const hasConsent = (() => {
      try {
        const storedConsent = window.localStorage.getItem("cookiesConsent");
        return storedConsent === null ? true : storedConsent === "true";
      } catch (error) {
        return true;
      }
    })();

    if (!hasConsent) {
      return;
    }

    const googletag = (window.googletag = window.googletag || { cmd: [] });
    let slot = null;
    let isUnmounted = false;

    googletag.cmd.push(() => {
      if (isUnmounted) {
        return;
      }

      const targetEl = document.getElementById(id);
      if (!targetEl || targetEl.dataset.adSlotInitialized === "true") {
        return;
      }

      let mapping = googletag
        .sizeMapping()
        .addSize(
          [1024, 768],
          [
            [970, 250],
            [728, 250],
            [970, 90],
            [728, 90],
          ]
        )
        .addSize([640, 480], [300, 250])
        .addSize(
          [0, 0],
          [
            [300, 250],
            [300, 75],
          ]
        )
              .build();

      slot = googletag.defineSlot(path, size, id);
      if (!slot) {
        return;
      }

      slot.addService(googletag.pubads()).defineSizeMapping(mapping);
      targetEl.dataset.adSlotInitialized = "true";

      if (!window.__ptdcGoogletagServicesEnabled) {
        googletag.pubads().enableSingleRequest();
        googletag.enableServices();
        window.__ptdcGoogletagServicesEnabled = true;
      }
    });

    googletag.cmd.push(() => {
      if (isUnmounted) {
        return;
      }

      if (!document.getElementById(id)) {
        return;
      }

      googletag.display(id);
    });

    return () => {
      isUnmounted = true;

      if (!slot) {
        return;
      }

      googletag.cmd.push(() => {
        googletag.destroySlots([slot]);
        const targetEl = document.getElementById(id);
        if (targetEl) {
          delete targetEl.dataset.adSlotInitialized;
        }
      });
    };
  }, [path, size, id]);
};

export default useAdManaSlot;
